import { useMutation } from '@tanstack/react-query';
import { getFavorites } from '../queries';

export function useGetFavorites() {
  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['getFavorites'], 
    mutationFn: () => getFavorites(),
    retry: false
  });

  return { mutate, isPending, isError };
}
